'use client';
import { useEffect, useState } from 'react';
import { api } from '@/lib/api';

export interface ErpCustomer {
  codigo: string;
  nome: string;
  cpf?: string | null;
  plano?: string | null;
  endereco?: string | null;
  diaVencimento?: number | null;
  conexao?: string | null;
  faturas?: { abertas: number; valorTotal: number } | null;
}

export function useCustomerByPhone(phone: string | null | undefined) {
  const [data, setData] = useState<ErpCustomer | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!phone) {
      setData(null);
      setError(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    api
      .request<ErpCustomer | null>(`/chat/customer/${encodeURIComponent(phone)}`, { method: 'GET' })
      .then((r) => { if (!cancelled) setData(r); })
      .catch((e) => { if (!cancelled) setError(e?.message ?? 'Erro ao buscar cliente'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [phone]);

  return { customer: data, loading, error };
}
